module.exports = __webpack_public_path__ + "img/amcharts-logo.01501c55.svg";